/*
 * Satismeter is initialized in html file but rest of the stuff is done here
 */

const SATISMETER_KEY = process.env.REACT_APP_SATISMETER_KEY;
const SATISMETER_EVENTS = {
	login: "login",
	locationToggle: "location_toggle",
	cataloguePublish: "catalogue_publish",
	requestToGoLive: "request_to_go_live",
	menuOverCatalogueCSAT: "menu_v2_csat",
	rewindCarousel: "rewind_carousel_closed",
	itemLogsViewed: "item_logs_viewed",
	heatMapCellDrillDown: "heat_map_cell_drill_down",
	locationGroupFilterApplied: "location_group_filter_applied",
	orderFrequencySubModuleAccessed: "order_frequency_sub_module_accessed",
	lostOrdersSubModuleAccessed: "lost_orders_sub_module_accessed",
	scheduledReportCreated: "scheduled_report_created",
	scheduledReportsPaused: "scheduled_reports_paused",
	comparisonCreated: "comparison_created",
	customerModuleAccessed: "customer_module_accessed",
	heatmapTabClicked: "heatmap_tab_clicked",
	periscopeModuleAccessed: "periscope_module_accessed",
	periscopeActivityLogAccessed: "periscope_activity_log_accessed",
	storeActionReportDownload: "store_action_report_download",
	itemWiseOrderTransactionReportDownload: "item_wise_order_transaction_report_download",
	optionsWiseOrderTransactionsReportDownload: "options_wise_order_transactions_report_download",
	orderTransactionsReportDownload: "order_transactions_report_download",
	payoutSheetUploaded: "payout_sheet_uploaded",
	periscopeFilterApplied: "periscope_filter_applied",
	switchedToOldNavigation: "switched_to_old_navigation"
};

class SatismeterService {
	static isUrbanPiperUser = true;

	static userInit(loginData) {
		if (loginData) {
			const traits = {
				biz_name: loginData?.loggedInbizDetail?.name,
				biz_id: loginData?.loggedInbizDetail?.id,
				email: loginData?.loginDetail?.email,
				phone: loginData?.loginDetail?.phone,
				isdCode: loginData?.loginDetail?.isdCode,
				company: loginData?.loggedInbizDetail?.name,
				name: loginData?.loginDetail?.fullName
			};

			this.isUrbanPiperUser = loginData?.loginDetail?.email?.includes("@urbanpiper.com");
			const userId = loginData?.loginDetail?.id;

			// don't initialize satismeter for urbanpiper users
			if (this.isUrbanPiperUser) return;

			if (window.satismeter) {
				window.satismeter({
					writeKey: SATISMETER_KEY,
					userId: userId,
					traits: traits
				});
			}
		}
	}

	static locationToggle() {
		if (this.isUrbanPiperUser) return;
		window.satismeter("track", {
			event: SATISMETER_EVENTS.locationToggle
		});
	}

	static menuPublish() {
		if (this.isUrbanPiperUser) return;
		window.satismeter("track", {
			event: SATISMETER_EVENTS.cataloguePublish
		});
	}

	static requestToGoLive() {
		if (this.isUrbanPiperUser) return;
		window.satismeter("track", {
			event: SATISMETER_EVENTS.requestToGoLive
		});
	}
	static menuOverCatalogueEvents() {
		if (this.isUrbanPiperUser) return;
		window.satismeter("track", {
			event: SATISMETER_EVENTS.menuOverCatalogueCSAT
		});
	}
	static rewindCarousel() {
		if (this.isUrbanPiperUser) return;
		window.satismeter("track", {
			event: SATISMETER_EVENTS.rewindCarousel
		});
	}

	static satismeterEvent(key) {
		if (this.isUrbanPiperUser) return;
		if (SATISMETER_EVENTS?.[key]) {
			window.satismeter("track", {
				event: SATISMETER_EVENTS?.[key]
			});
		}
	}
}

export default SatismeterService;
